import React, { useState } from "react";
import styles from "../assets/css/Validation.module.css";
import Modal from "../components/Modal";
import DetalleModal from "../components/DetalleModal";
import ParticleBackground from "../components/ParticleBackground";
import { motion } from "framer-motion";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const solicitudesMock = [
  {
    id: 1,
    tipo: "Autorización",
    estado: "Aprobada",
    fecha: "2025-08-15",
    detalle: "Autorización para medicamento A",
  },
  {
    id: 2,
    tipo: "Cancelación",
    estado: "Pendiente",
    fecha: "2025-08-20",
    detalle: "Cancelación de orden 123",
  },
  {
    id: 3,
    tipo: "Autorización",
    estado: "Pendiente",
    fecha: "2025-08-22",
    detalle: "Autorización para medicamento B",
  },
];

export default function Autorizaciones() {
  const [solicitudes, setSolicitudes] = useState(solicitudesMock);
  const [filtro, setFiltro] = useState("Todas");
  const [busqueda, setBusqueda] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [detalle, setDetalle] = useState(null);

  const handleNuevaSolicitud = (nueva) => {
    setSolicitudes((prev) => [...prev, nueva]);
    setShowModal(false);
    toast.success("Solicitud creada con éxito", {
      position: "top-right",
      autoClose: 3000,
    });
  };

  const solicitudesFiltradas = solicitudes.filter((s) => {
    const coincideFiltro =
      filtro === "Todas" || s.tipo.toLowerCase() === filtro.toLowerCase();
    const coincideBusqueda =
      s.detalle.toLowerCase().includes(busqueda.toLowerCase()) ||
      s.id.toString().includes(busqueda);
    return coincideFiltro && coincideBusqueda;
  });

  return (
    <div className={styles.validationContainer}>
      <ParticleBackground />
      <ToastContainer />

      <motion.div
        className={styles.validationContent}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className={styles.header}>
          <h2>Solicitudes de Autorizaciones / Cancelaciones</h2>
          <motion.button
            className={styles.addBtn}
            onClick={() => setShowModal(true)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            + Nueva Solicitud
          </motion.button>
        </div>

        {/* Filtros y búsqueda */}
        <div className={styles.filters}>
          <select
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
            className={styles.select}
          >
            <option value="Todas">Todas</option>
            <option value="Autorización">Autorizaciones</option>
            <option value="Cancelación">Cancelaciones</option>
          </select>

          <input
            type="text"
            placeholder="Buscar por ID o detalle"
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            className={styles.search}
          />
        </div>

        {/* Tabla */}
        <table className={styles.table}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Tipo</th>
              <th>Estado</th>
              <th>Fecha</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {solicitudesFiltradas.map((s) => (
              <tr key={s.id}>
                <td>{s.id}</td>
                <td>{s.tipo}</td>
                <td
                  className={
                    s.estado === "Aprobada" ? styles.aprobada : styles.pendiente
                  }
                >
                  {s.estado}
                </td>
                <td>{s.fecha}</td>
                <td>
                  <button
                    className={styles.detailBtn}
                    onClick={() => setDetalle(s)}
                  >
                    Ver Detalle
                  </button>
                </td>
              </tr>
            ))}
            {solicitudesFiltradas.length === 0 && (
              <tr>
                <td colSpan="5" className={styles.noData}>
                  No hay solicitudes que coincidan.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Modal de creación */}
        {showModal && (
          <Modal
            onClose={() => setShowModal(false)}
            setAutorizaciones={setSolicitudes}
          />
        )}

        {/* Modal de detalle */}
        <DetalleModal solicitud={detalle} onClose={() => setDetalle(null)} />
      </motion.div>
    </div>
  );
}
